module.exports = __webpack_public_path__ + "static/img/22.cd894da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/22.png
// module id = v12h
// module chunks = 0